var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_482_18067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6075 17.1536L26.6684 25.0493C26.4223 25.4427 26.0033 25.5974 25.6258 25.4341C25.4563 25.3608 25.3076 25.2268 25.1957 25.0465L20.2861 17.1325C20.1037 16.8385 20.0792 16.5265 20.2186 16.2763C20.3581 16.0262 20.6365 15.8832 20.9825 15.8838L24.2121 15.8898C23.6967 13.2434 21.9291 10.8856 19.2731 9.73692C14.9967 7.88736 10.0128 9.86182 8.16328 14.1382C6.31372 18.4146 8.28807 23.3985 12.5645 25.2481C13.3938 25.6068 13.7752 26.5697 13.4166 27.3989C13.0579 28.2282 12.095 28.6096 11.2658 28.251C5.33354 25.6853 2.59469 18.7717 5.16041 12.8394C7.72614 6.9072 14.6397 4.16835 20.572 6.73408C24.4648 8.41776 26.9824 11.9737 27.5284 15.896L30.9159 15.9023C31.0654 15.9026 31.2017 15.9289 31.3212 15.9806C31.5249 16.0687 31.6714 16.2275 31.7337 16.4278C31.8039 16.6535 31.7591 16.9113 31.6075 17.1536Z",
    fill: "#FFCA56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_18067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "matrix(0.917833 0.396967 0.396967 -0.917833 0 24.7712)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.a3b8e8715a87c4850e86751fbe6ac2c1.svg";
export { ForwardRef as ReactComponent };